<template>
  <el-dialog
    :visible.sync="dialogVisible"
    size="spec"
    :close-on-click-modal="true"
    :append-to-body="true"
    :class="b()"
  >
    <div
      :class="b('title')"
    >
      {{ $t('highlights.title') }}
      <div :class="b('sub')">
        {{ $t('highlights.subTitle') }}
      </div>
    </div>
    <div :class="b('content', { big:list.length>3 })">
      <GuideScene
        :list="list"
        :favorite="false"
        from="sassApp"
      ></GuideScene>
    </div>

    <div
      :class="b('dialog-footer')"
    >
      <div :class="b('right')">
        <el-button
          :loading="MQLoading"
          @click="handleConnect"
        >
          <span>
            <ImageOrIcon
              symbol
              :size="16"
              src="iconkefu"
            />
            {{ $t('highlights.connect') }}</span>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import GuideScene from 'common-module/src/components/GuideScene';
export default {
  name: 'Highlights',
  components: { GuideScene },
  props:{
    lightsData:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      list:[],
      MQLoading: false
    };
  },
  computed: {

  },
  mounted(){
    this.eventBus.$on('showVideo-highlights', this.showHighlights);
  },
  beforeDestroy(){
    this.eventBus.$off('showVideo-highlights', this.showHighlights);
  },
  bemNS: theme.bemNS,
  created(){
    this.list = [...this.lightsData.recommendList, ...this.lightsData.otherList].map(item=>({ ...item, status: 1 })) || [];
  },
  methods: {
    async handleClose() {
      this.dialogVisible = false;
      this.$track.send('UserGuide_Explore', {}, true);
    },
    changeVisible(visible) {
      this.dialogVisible = visible;
    },
    showHighlights(){
      this.dialogVisible = true;
    },
    handleConnect(){
      this.MQLoading = true;
      // eslint-disable-next-line
      this.eventBus.$emit('global:openMeiQia', () => {
        this.MQLoading = false;
      });
      //  window._MEIQIA?.('showPanel');
    }
  }
};
</script>

<style lang="scss" scoped>
 @include b(highlights) {
    display: flex;
    align-items: center;
    min-width: 1080px;
    ::v-deep {
      .el-dialog {
        width: auto;
        min-width: 1080px;
        border-radius: 16px;
        margin: auto !important;
      }
      .el-dialog__header {
        padding: 60px;
        padding-bottom: 0px;
        height: auto;
      }
      .el-dialog__body {
        padding: 0px 0px 30px;
        overflow-x: hidden;
      }
    }
    @include e(title) {
      font-size: 32px;
      font-weight: var(--weight-font-Semiblod);
      text-align: center;
      @include e(sub){
        margin-top: 4px;
        font-size: 14px;
      }
    }
   @include e(content){
      width: 100%;
      padding: 24px 60px 0px;
      @include m(big){
        width: 1280px;
      }
   }
    @include e(dialog-footer) {
      padding: 0 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      margin-top: 30px;
      @include e(right){
        display: flex;
        align-items: center;
        ::v-deep{
          .el-button{
              height: 40px;
              width: 120px;
          }
          .el-button + .el-button{
            margin-left: 16px;
          }
        }
      }
    }
  }
  @media (max-height: 800px) {
    @include b(highlights) {
      min-width: 1000px;
      ::v-deep {
        .el-dialog {
          min-width: 1000px;
          .el-dialog__header {
          padding: 30px;
          padding-bottom: 0px;
        }
          .el-dialog__body {
            padding: 0px 0px 30px;
          }
            }
        }
      @include e(content){
        padding: 14px 30px 0px;
        @include m(big){
          width: 1220px;
        }
      }
      @include e(dialog-footer) {
        margin-top: 20px;
        padding: 0 30px;
      }
    }

  }
</style>
